import { render, staticRenderFns } from "./ConfirmUserModal.vue?vue&type=template&id=be16cd64&"
import script from "./ConfirmUserModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports